import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { billingActions } from "../../../../../../_actions/billing.actions";
import _ from "lodash";
import {OrganizationBillingsBuilder} from "../objects/OrganizationBillingsBuilder";

export default function (range, orgName) {
    const dispatch = useDispatch();

    useEffect(() => {
        if (!range?.startDate || !range?.endDate || !orgName) {
            return;
        }

        const params = {
            startDate: range?.startDate,
            endDate: range?.endDate,
            organizationName: orgName
        };

        dispatch(billingActions.getOrganizationBillingBreakdown(params));
    }, [range?.startDate, range?.endDate, orgName]);

    const billings = useSelector((state) => state.billing);
    const loading = billings?.loadingOrganizationBillings;
    const organizationBillings = _.get(billings, "organizationBillings.items", []);
    const rows = [];

    if(!loading && organizationBillings.length > 0) {
        organizationBillings.map( (billing, index) => {
            const builder = new OrganizationBillingsBuilder()
            builder.setOrganizationName(_.get(billing, 'organizationName') || '-')
            builder.setBillingDate(_.get(billing, 'billingDate') || '-')
            builder.setAmountCharged(_.get(billing, 'amountCharged') || '-')
            builder.setProductSku(_.get(billing, 'productSku') || '-')
            builder.setChannelType(_.get(billing, 'channelType') || '-')
            rows.push(builder.billing)
        })
    }

    const totalCount = rows.length

    const columns = [
        {
            id: "organizationName",
            label: "Organization Name",
            width: 150,
        },
        {
            id: "billingDate",
            label: "Billing Date",
            width: 100,
            isSortable: true,
        },
        {
            id: "amountCharged",
            label: "Amount Charged",
            width: 100,
            isSortable: true,
            align: "right",
            format: (value) => value.toLocaleString("en-US"),
        },
        {
            id: "productSku",
            label: "Product SKU",
            width: 100,
            isSortable: true,
        },
        {
            id: "channelType",
            label: "Channel Type",
            width: 100,
            isSortable: true,
        },
    ];

    return { rows, columns, totalCount, loading };
}
